// extracted by mini-css-extract-plugin
export default {"btn2":"masterSign_btn2__qeS1w"};